import { isInside } from './util';

export class CalendarResizeHelper {
  constructor(
    private resizeContainerElement: HTMLElement,
    private minWidth: number,
    private rtl: boolean
  ) {}

  validateResize({ rectangle, edges }): boolean {
    if (this.rtl) {
      // TODO - find a way of testing this, for some reason the tests always fail but it does actually work
      /* istanbul ignore next */
      if (typeof edges.left !== 'undefined') {
        rectangle.left -= edges.left;
        rectangle.right += edges.left;
      } else if (typeof edges.right !== 'undefined') {
        rectangle.left += edges.right;
        rectangle.right -= edges.right;
      }
      rectangle.width = rectangle.right - rectangle.left;
    }

    if (
      this.minWidth &&
      Math.ceil(rectangle.width) < Math.ceil(this.minWidth)
    ) {
      return false;
    }

    return isInside(
      this.resizeContainerElement.getBoundingClientRect(),
      rectangle
    );
  }
}
